import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../api/apiSlice";
import { concatPathWithParams } from "../../api/apiHelper";

const rawDataAdapter = createEntityAdapter();

const initialState = rawDataAdapter.getInitialState();

export const rawDataAPISlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDeviceInfo: builder.query({
            query: (deviceID) => `/device/${deviceID}/`,
            providesTags: ["device_info"],
        }),
        getDeviceRawData: builder.query({
            query: (request) =>
                concatPathWithParams(
                    `/device/${request.deviceID}/rawdata/`,
                    request.queryParams
                ),
            providesTags: ["device_raw_data"],
        }),
    }),
});

export const { useGetDeviceInfoQuery, useGetDeviceRawDataQuery } =
    rawDataAPISlice;
